import { useEffect, useLayoutEffect } from 'react';

/* 
    Server side render useLayoutEffect without a warning
    In the browser, it uses `useLayoutEffect`, but in SSR, it uses `useEffect`
*/
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

export default useIsomorphicLayoutEffect;
